export enum ViewMode {
    VIEW = 1,
    EDIT = 2,
    ADD = 3
}